import { FC, PropsWithChildren } from "react";

interface Props {
  width?: number;
  height?: number;
  white?: boolean;
}
export const Spinner: FC<PropsWithChildren<Props>> = ({
  width = 150,
  height = 150,
  white = false,
  ...rest
}) => {
  return (
    <img
      className="animate-spin"
      src={white ? "/spinner-white.svg" : "/spinner.svg"}
      alt="Loading"
      width={width}
      height={height}
      {...rest}
    />
  );
};
